module.exports = __webpack_public_path__ + "img/pop_hong@2x.401603a3.png";